
import { Component, Vue, Prop } from 'vue-property-decorator'
import Pagination from './Pagination.vue'
import Filters from './Filters.vue'

@Component({ components: { Pagination, Filters } })
export default class FiltersHeader extends Vue {
  @Prop({ default: 5, required: false }) maxVisibleButtons: number
  @Prop({ default: null, required: true }) totalPages!: number
  @Prop({ default: null, required: true }) total!: number
  @Prop({ default: null, required: true }) perPage!: number
  @Prop({ default: null, required: true }) currentPage!: number

  pageSize: number = 6
}
